/**
 * @author Ryan Gladstone
 */

function TasksFeedController(
  $scope,
  entity,
  searchService,
  permissionsService,
  featureFlag,
  $http,
  $window
) {
  $scope.entity = entity;
  $scope.search = searchService.search({
    name: 'tasksSearch',
    type: 'tasks',
    refresh: true,
    entity
  });
  $scope.refresh = $scope.search.refresh;
  $scope.filterSet = $scope.search.filterSet;

  featureFlag.isEnabled('tasksv2').then((enabled) => {
    if (enabled) {
      $window.location.href = '/websked/1/tasks';
    }
  });

  $scope.$on('$destroy', () => {
    $scope.search.tearDown();
  });

  $scope.deleteTask = (id) => {
    const taskToRemove = $scope.search.results.filter(
      (task) => task.id === id
    )[0];

    const indexOfTarget = $scope.search.results.indexOf(taskToRemove);

    $scope.search.results.splice(indexOfTarget, 1);
  };

  $scope.deleteAllTasks = () => {
    const taskArray = [];
    $scope.search.results.map((t) => taskArray.push(t.id));

    $http({
      method: 'DELETE',
      url: 'api/tasks',
      headers: {
        'Content-Type': 'application/json'
      },
      data: taskArray
    }).then(
      () => {
        $window.location.reload();
      },
      (response) => {
        console.log('response', response);
      }
    );
  };

  $scope.canDeleteAll = () =>
    $scope.search.results &&
    $scope.search.results.length &&
    $scope.search.results.every((task) =>
      permissionsService.isAuthorized('TD', task.website)
    );
}

const TasksFeedControllerArray = [
  '$scope',
  'entity',
  'searchService',
  'permissionsService',
  'featureFlag',
  '$http',
  '$window',
  TasksFeedController
];

export default function (ngModule) {
  ngModule.controller('TasksFeedController', TasksFeedControllerArray);
}
